.body {
	flex: 1 1 0%;
	display: flex;
	flex-direction: column;
	overflow: auto;
	gap: var(--size-8);
}

.settingRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: var(--size-4);
}

.settingInfo {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
}

.settingActions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.settingLabel {
	font-weight: 600;
}

.settingDescription {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.sectionTitle {
	font-size: var(--text-subtitle-1);
	margin-top: var(--size-8);
}

.form {
	display: flex;
	align-items: flex-end;
	gap: var(--size-5);
}

.actions {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-end;
	gap: var(--size-3);
}

.error {
	max-width: 18rem;
	margin: 0;
	color: var(--color-error-text);
	font-size: var(--text-caption);
	text-align: right;

	&:empty {
		display: none;
	}
}
